<template>
  <div style="padding-bottom: 40px;background-color:#f0f0f0;" v-if="body_show">
    <div class="cep61_top">
      <h1 class="text-ellipsis">{{data.headtitle}}</h1>
      <h2>测试者：{{data.nickname}}</h2>
      <h3>{{data.ctime}}</h3>
      <!-- <img class="logo" src="@a/xjy-logo.png" /> -->
    </div>
    <div>
      <div class="cep_main">
        <div class="h_spe">我的信息档案</div>
        <div class="h_main">
          <van-icon size="40px" class="icon" name="manager-o" />
          <div class="h-main-right" >
            <!-- <h4  v-for="(item,index) in Object.keys(data.result.extra)" :key="index"><van-icon name="label-o" />{{item+'：'+data.result.extra[item]}}</h4> -->
            <h4><van-icon name="label-o" />{{'性别：'+data.result.extra['性别']}}</h4>
            <h4><van-icon name="label-o" />{{'学历：'+data.result.extra['学历']}}</h4>
            <h4><van-icon name="label-o" />{{'工作年限：'+data.result.extra['工作年限']}}</h4>
            <h4><van-icon name="label-o" />{{'职业身份：'+data.result.extra['职业身份']}}</h4>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="cep_main on mt4">
        <h6 class="small">根据你提供的信息，我们为你推荐下面两个副业方向。点击了解详情：</h6>
        <a class="cep-card-f" :href="'#'+item.name" v-for="(item,index) in recommend_list" :key="index">
          <div  class="cep-card">
              <h5>{{item.name}}</h5>
              <div class="cep-match">
                优势匹配
                <van-rate class="cp-icon" v-model="item.match" readonly  />
              </div>
              <div class="cep-payback">
                职业回报
                <van-rate  class="cp-icon" icon="like" void-icon="like-o" v-model="item.payback" readonly  />
              </div>
          </div>
        </a>
      </div>
      <!--  -->
       <div class="cep_main on" v-for="(item,index) in recommend_list" :key="index">
        <div :id="item.name" class="h_1 text-ellipsis">推荐方向：{{item.name}}</div>
        <div  v-for="(itm,idx) in item.detail" :key="idx">
          <div class="h_2 on" ><van-icon size="20px" class="icon" name="medel-o" />{{itm.title}}</div>
          <h5 v-if="itm.before" class="before">{{itm.before}}</h5>
          <div  class="h-box"  v-html="itm.text"></div>
          <table v-if="(itm.intro && itm.intro.length>0) || (itm.prof && itm.prof.length>0)" width="100%" class="cep-table" border="1px" cellspacing="0" cellpadding="0">
            <thead>
              <tr>
                <th width="25%">推荐课程</th>
                <th width="25%">学习时长</th>
                <th width="50%">学习成效</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(titm,tidx) in itm.intro" :key="tidx">
                <td>{{titm.name}}</td>
                <td>{{titm.time}}</td>
                <td>{{titm.result}}</td>
              </tr>
              <tr v-for="(pitm,pidx) in itm.prof" :key="pidx">
                <td>{{pitm.name}}</td>
                <td>{{pitm.time}}</td>
                <td>{{pitm.result}}</td>
              </tr>
            </tbody>
          </table>
          <h5 v-if="itm.after" class="after">{{itm.after}}</h5>
        </div>
        
      </div>
    </div>
    <!-- 关注二维码 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
    <!-- 兴趣选项 -->
    <van-popup class="get-welfare"  v-model="getWelfareBool">
      <div class="get-welfare-pop">
        <h3>请勾选你感兴趣的资料选项，稍后我们的顾问会联系你并为你提供资料。</h3>
        <van-checkbox-group v-model="getwelfare">
          <van-checkbox shape="square"  name="<直播>古典：疫情过后，第二职业有哪些新机会"><直播>古典：疫情过后，第二职业有哪些新机会</van-checkbox>
          <van-checkbox shape="square"  name="<课程>猎聘事业部总监教你如何持续转型实现职场跃迁"><课程>猎聘事业部总监教你如何持续转型实现职场跃迁</van-checkbox>
          <van-checkbox shape="square"  name="<分享>副业变现：我是如何用半年时间赚回几万学费的？"><分享>副业变现：我是如何用半年时间赚回几万学费的？</van-checkbox>
          <van-checkbox shape="square" class="on" name="<案例>职业发展顾问服务成功故事集（点击“提交”快速获取）"><案例>职业发展顾问服务成功故事集（点击“提交”快速获取）</van-checkbox>
        </van-checkbox-group>
        <a class="subBtn" @click="saveWelfare()">提交</a>
      </div>
    </van-popup>
    <!-- 提交兴趣后展示 -->
    <van-popup class="get-welfare"  v-model="qrcodeBool">
      <div v-if="data.content" class="get-welfare-pop" v-html="data.content"></div>
      <div v-else class="get-welfare-pop">
        <h3>点击以下网盘链接，输入提取码，获取《职业发展顾问服务成功故事集》</h3>
        <h4 v-clipboard:copy="'链接: https://pan.baidu.com/s/1dqYIKCF78tpj5fRbS7m-iw 提取码: c8kv '" v-clipboard:success="onCopy" v-clipboard:error="onError">链接: https://pan.baidu.com/s/1dqYIKCF78tpj5fRbS7m-iw<br/>提取码: c8kv </h4>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { evaluation, ceping72_reset,ceping72_save_extra} from "@/api/measurement";
import { getStorage, setStorage, isMain} from "@/utils/tools";
import { shareCon} from "@/utils/wxconfig";
import { Dialog} from 'vant';
import Viser from 'viser-vue';
import DataSet from '@antv/data-set';
import { registerShape} from 'viser-vue';
Vue.use(Viser);

export default {
  data() {
      return {
        body_show: false,
        data: {},
        isShow: false,
        qrcode: '',
        type_obj: {
          headtitle: ""
        },
        recommend_list:[],
        getWelfareBool:false,
        getwelfare:[],
        qrcodeBool:false
      }
    },
    methods: {
      // 复制成功
      onCopy(e) {
        this.$toast('复制成功!');
      },
      // 复制失败
      onError(e) {
        this.$toast('复制失败');
      },
      // 提交兴趣
      saveWelfare(){
        if(!this.getwelfare){
          this.$toast('请先选择兴趣资料！');
          return
        }
        //调用加载中
        this.$emit('loadingHandle',true,"提交中");
        ceping72_save_extra({
          key:'获取资料',
          value:this.getwelfare.join(','),
          evaluation_id:this.data.evaluation_id
        }).then((data)=>{
          //关闭加载中
          this.$emit('loadingHandle',false);
          if (data.code == 10002) {
            this.$toast(data.data.msg);
            return false;
          }
          this.$toast('提交成功！');
          this.getWelfareBool = false;
          this.qrcodeBool = true;
          this.getwelfare = [];
        })
      },
      // 换行回车替换成标签
      Trim(str) {
        return str.replace(/\n/g, '<br />');
      },
      pullData() {
        let q = this.$route.query;
        evaluation({
          evaluation_id:this.$route.query.evaluation_id,
          evaluation_md5:this.$route.query.evaluation_md5
        }).then((data) => {
          if (data.code != '10002') {
            document.title = data.headtitle;
            this.body_show = true;
            this.data = data;
            this.qrcode = data.qrcode;
            
            if (this.data.need_subscribe && !this.data.subscribe) {
              this.isShow = true;
            };
            this.recommend_list  = data.result.recommend_list;
            // 给wxconfig传对象
            this.type_obj.headtitle = data.headtitle;

            shareCon("ceping72", this, this.type_obj);
          } else {
            if(data.msg==='测评未完成'){
              this.$toast(data.msg);
              // 没有完成测评
              this.$router.push({
                path:"/ceping72",
                query: q.eid
              })
            }else{
              this.$toast(data.msg);
              return
            }
          }
        })
      },
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss">
@import "@s/remChange.scss";
// 获取福利
.get-welfare{
  background: transparent;
  .get-welfare-pop{
    background: #fff;
    border-radius: 15px;
    padding: 60px 30px;
    width:650px;
    h3{
      font-size:32px;
      color:#2eb6a8;
      line-height:40px;
      margin-bottom:50px;
    }
    h4{
      font-size:28px;
      color:#666666;
      cursor: pointer;
      word-wrap:break-word;
    }
    .van-checkbox{
      margin-bottom:30px;
      display: flex;
      align-items: center;
      .van-checkbox__label{
        font-size:28px;
      }
    }
    .van-checkbox.on{
      margin-bottom:90px;
    }
    a{
      display:block;
      text-align:center;
      font-size:32px;
      color:#ffffff;
      background-color:#2eb6a8;
      line-height:80px;
      border-radius:15px;
      margin-top:30px;
    }
    .qrcode{
      width:400px;
      display:block;
      margin:0 auto;
    }
  }
}

// 
.dimension_bg {
  background: url(../../../assets/dema_bg.png) no-repeat top center;
  background-size: cover;
  width: 100%;
  height: 630px;
}

.dimension {
  margin: 0 auto;
  height: 510px;
  margin: 30px auto;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  position: relative;
}

.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #F57F17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

.cep61_top {
  width: 100%;
  background: url(../../../assets/cep_t_new.png) no-repeat top center;
  background-size: cover;
  height: 470px;
  padding: 0 30px;
  padding-top: 72px;
  color: #2A877F;
  h1 {
    font-size: 50px;
    font-weight: bold;
    border-bottom: 8px solid #2A877F;
    padding-bottom: 10px;
    display: inline-block;
    margin-top: 30px;
  }
  h2 {
    font-size: 26px;
    margin-top: 30px;
  }
  h3 {
    font-size: 20px;
    margin-top: 20px;
  }
  a {
    display: block;
    margin-top: 40px;
    width: 240px;
    height: 55px;
    background: #2A877F;
    border-radius: 8px;
    font-size: 30px;
    color: #fff;
    line-height: 55px;
    text-align: center;
  }
  .logo{
    width:180px;
    position: absolute;
    top: 25px;
    right: 25px;
  }
}

.cep_main {
  width: 690px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 110px;
  box-shadow: 0px 0px 10px #bbbbbb;
  padding-top: 0;
  padding-bottom: 60px;
  text-align: center;
  .h_spe {
    width: 209px;
    height: 50px;
    background: rgba(46, 182, 168, 1);
    border-radius: 0px 23px 23px 0px;
    line-height: 50px;
    text-align: center;
    font-size: 30px;
    color: #fff;
  }
  .h_main{
    display:flex;
    align-items: center;
    .icon{
      width:150px;
      color:#2eb6a8;
    }
    .h-main-right{
      flex:1;
      color:#2eb6a8;
      font-size:26px;
      h4{
        display:flex;
        align-items: center;
        text-align: left;
        line-height:60px;
      }
    }
  }
  .h_1 {
    width: 590px;
    height: 74px;
    background: rgba(46, 182, 168, 1);
    border-radius: 37px;
    line-height: 74px;
    color: #fff;
    font-size: 38px;
    margin: 0 auto;
    top: -37px;
    text-align: center;
    position: relative;
  }
  .h-box{
    padding-left:20px;
    text-align:left;
    table{
      width:100%  !important;
    }
  }
  .h_2 {
    color: #2EB6A8;
    font-size: 32px;
    margin-top: 40px;
    margin-left: 20px;
    text-align: left;
    span {
      display: inline-block;
      width: 6px;
      height: 30px;
      background: rgba(46, 182, 168, 1);
      border-radius: 3px;
      margin-right: 20px;
      vertical-align: middle;
    }
  }
  .h_3 {
    font-size: 28px;
    color: #333;
    font-weight: bold;
    margin: 0 46px;
    margin-top: 80px;
    text-align: left;
  }
  .h_img {
    width: 598px;
    margin: 0 auto;
    margin-top: 40px;
  }
  .h_results {
    width: 598px;
    height: 188px;
    background: rgba(245, 253, 252, 1);
    margin: 0 auto;
    padding: 0 20px;
    border-top: 8px solid #2EB6A8;
    h2 {
      color: #333;
      font-size: 26px;
      margin-top: 40px;
      text-align: left;
      line-height: 24px;
      span {
        font-size: 32px;
        color: #2EB6A8
      }
    }
  }
}
.cep_main.on{
  margin-top:80px;
  padding:0px 30px 50px;
  .cep-table{
    border-collapse: collapse;
    border-color: #bbbbbb;
    thead tr th{
      padding:0px 8px;
      line-height: 80px;
      background-color: #6C63FF;
      color: #ffffff;
      font-size: 28px;
      font-weight: bold;
    }
    tbody tr td{
      padding: 15px;
      font-size: 24px;
      color: #666666;
      text-align: left;
    }
  }
  .getWelfareBtn{
    background-color: #2EB6A8;
    display:block;
    font-size:34px;
    text-align:center;
    color:#ffffff;
    line-height:98px;
    margin-top:30px;
    border-radius: 8px;
    text-decoration: underline;
    letter-spacing: 5px;
  }
  .h_1 {
    font-size:30px;
  }
  .h_2.on{
    display:flex;
    align-items: center;
    margin-bottom:20px;
    font-weight: bold;
    .icon{
      margin-right:20px;
    }
  }
  .before{
    font-size:28px;
    padding-left: 20px;
    margin-bottom: 20px;
    margin-top: 20px;
    text-align: left;
  }
  .after{
    font-size:28px;
    color:#E53333;
    padding-left: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: left;
  }
  h6.small{
    font-size:26px;
    color:#666666;
    text-align:left;
    padding-top:30px;
  }
  .cep-card-f{
    display:block;
    border-radius:15px;
    background-color:#2eb6a8;
    &:nth-child(odd){
      background-color:#6C63FF;
    }
    .cep-card{
      box-shadow: 0px 5px 10px #ccc;
      border-radius:15px;
      padding:30px;
      margin-top:30px;
      color:#ffffff;
      h5{
        text-align:left;
        font-size:30px;
        margin-bottom:30px;
      }
      .cep-match,.cep-payback{
        display:flex;
        align-items:center;
        justify-content: center;
        font-size:26px;
        .cp-icon{
          margin-left:20px;
        }
      }
    }
  }
}
.cep_main:first-child {
  padding-top: 24px;
  margin-top: 60px;
}
.cep_main.on.mt4{
  margin-top:50px;
}
.getWelfareBtn-new{
    background-color: #2EB6A8;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width:100%;
    max-width:750px;
    display:block;
    font-size:34px;
    text-align:center;
    color:#ffffff;
    line-height:98px;
    text-decoration: underline;
    letter-spacing: 5px;
  }
</style>
